import { cn } from 'cn';
import { useTranslation } from 'react-i18next';

import { useQueryAnalyticsKpi } from '~/data/analytics';

import { i18n } from '~/utils';

import { withErrorBoundary } from '@vestigas/ui';

import { getKpiProps, useDateRange } from '../utils';

import { KPI } from './KPI';

/**
 * KpiUsersRegistered
 *
 * Displays the number of registered users for the selected date range.
 */
export const KpiUsersRegistered = withErrorBoundary(
  ({ className, style }: ComponentStyling) => {
    const { t } = useTranslation('analytics');

    const dateRange = useDateRange();

    const { data, isFetching } = useQueryAnalyticsKpi({
      dateRange,
      kpiName: 'registered_users',
    });

    const kpi = getKpiProps({
      iconMetaphor: 'users',
      kpiColor: 'text-blue-800',
      label: t(($) => $.usage.generalUsage.registeredUsers),
      previousValue: data?.previousValue,
      tooltip: t(($) => $.usage.generalUsage.registeredUsersTooltip),
      value: data?.value,
    });

    return (
      <KPI
        className={cn(
          'rounded-lg border border-blue-300 bg-blue-100 p-4',
          className,
        )}
        style={style}
        isLoading={isFetching}
        {...kpi}
      />
    );
  },
  i18n.t(($) => $.errorBoundary.fallbackMessage, {
    ns: 'analytics',
    section: i18n.t(($) => $.usage.generalUsage.registeredUsers, {
      ns: 'analytics',
    }),
  }),
);

KpiUsersRegistered.displayName = 'KpiUsersRegistered';
